export default "__VITE_ASSET__BIloZu7U__"